import { useState } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { HeaderMenuFooterItemProps } from "../interfaces";

const HeaderMenuFooterItem = (props: HeaderMenuFooterItemProps) => {
	const [hov, setHov] = useState(false);

	return (
		<>
			{props.loading ? (
				<div className="w-full h-5 p-1">
					<div className="animate-pulse bg-gray-300 rounded-md h-6 mx-5" />
				</div>
			) : (
				<Link
					className={clsx("whitespace-nowrap", {
						"forbidden-access": !props.hasAccess,
					})}
					to={props.url}
				>
					<button
						disabled={!props.hasAccess}
						onMouseOver={() => setHov(true)}
						onFocus={() => setHov(true)}
						onMouseLeave={() => setHov(false)}
						className={clsx({
							"flex w-full items-center py-[5px]": true,
							"opacity-60": !props.hasAccess,
						})}
					>
						<div className="flex space-x-[18px] align-middle">
							<img src={hov ? props.iconHover : props.icon} alt="" className="w-5" />
							<div className="flex-1 whitespace-nowrap text-sm font-medium font-montserrat">{props.label}</div>
						</div>
					</button>
				</Link>
			)}
		</>
	);
};

const HeaderMenuFooter = (props: { footerItems?: HeaderMenuFooterItemProps[] }) => {
	const { footerItems } = props;
	if (!footerItems?.length) {
		return null;
	}

	return (
		<div className="text-[#666666] bg-[#F7F7F7] grid grid-cols-2 py-3 px-8">
			{footerItems?.map((subListItem) => (
				<HeaderMenuFooterItem key={`footer-item-${subListItem.label}`} {...subListItem} />
			))}
		</div>
	);
};

export default HeaderMenuFooter;
